import { render, staticRenderFns } from "./Policies.vue?vue&type=template&id=6777a3f0&"
import script from "./Policies.vue?vue&type=script&lang=js&"
export * from "./Policies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6777a3f0')) {
      api.createRecord('6777a3f0', component.options)
    } else {
      api.reload('6777a3f0', component.options)
    }
    module.hot.accept("./Policies.vue?vue&type=template&id=6777a3f0&", function () {
      api.rerender('6777a3f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/Policies.vue"
export default component.exports